import * as Sentry from "@sentry/react"
import { createRoot } from "react-dom/client"

import App from "./App.tsx"
import "./index.css"

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://03c2fc7d7a537e2e49d0ce2a434585b4@o4507254072213504.ingest.de.sentry.io/4512288732414032",
    dataCollection: {
      userInfo: false,
      httpBodies: [],
    },
    tracesSampleRate: 1.0,
  })
}

createRoot(document.getElementById("root")!).render(<App />)
